const SKILLS = {
    "frontend": [{
            id: 1,
            category: "front-end",
            name: "Flutter"
        },
        {
            id: 2,
            category: "front-end",
            name: "Dart"
        },
        {
            id: 3,
            category: "front-end",
            name: "React"
        },
        {
            id: 4,
            category: "front-end",
            name: "HTML"
        },
        {
            id: 5,
            category: "front-end",
            name: "CSS"
        }
    ],
    "backend": [{
            id: 1,
            category: "back-end",
            name: "Node"
        },
        {
            id: 2,
            category: "back-end",
            name: "Firebase Auth"
        },
        {
            id: 3,
            category: "back-end",
            name: "Firebase Cloud Functions"
        },
        {
            id: 4,
            category: "back-end",
            name: "Isar DB"
        },
        {
            id: 5,
            category: "back-end",
            name: "Hive DB"
        }
    ],
    "misc": [{
            id: 1,
            category: "misc",
            name: "REST"
        },
        {
            id: 2,
            category: "misc",
            name: "APIs"
        },
        {
            id: 3,
            category: "misc",
            name: "MVC"
        },
        {
            id: 4,
            category: "misc",
            name: "Git"
        },
        {
            id: 5,
            category: "misc",
            name: "Bash"
        }
    ]
}

export default SKILLS;